import type { Categories } from '../types/portfolio';

export const ROLE_SLUGS = [
    'pro',
    'pre',
    'en',
    'wr',
    'mix',
    'ma',
] as const

export type RoleSlug = (typeof ROLE_SLUGS)[number]

export const roles: Categories[] = [
    {
        label: 'Role',
        categories: [...ROLE_SLUGS],
    },
]

const ROLE_LABELS: Record<RoleSlug, string> = {
    pro: 'Production',
    pre: 'Pre-production',
    en: 'Engineering',
    wr: 'Writing',
    mix: 'Mixing',
    ma: 'Mastering',
}

export function roleSlugToLabel(slug: string): string {
    return ROLE_LABELS[slug as RoleSlug]
}

export function roleSlugsToLabels(slugs: string[]): string[] {
    return slugs.map((slug) => roleSlugToLabel(slug))
}
